<div [ngSwitch]="type">
    <div *ngSwitchDefault class="patient-card card" (click)="selectPatient()">
        <div class="row">
            <div class="col">
                <div class="card-body">
                    <h5 class="card-title"><b>{{patient.Name}}</b></h5>
                    <h6 class="card-subtitle mb-2 text-muted">Case no: {{patient.CaseNumber}}</h6>
                    <h6 *ngIf="discharged" class="card-subtitle mb-2 mt-2 text-muted">Discharge date:
                        {{patient.DischargedDate | date}}
                    </h6>
                    <div class="grid-chip-div">
                        <p class="patient-card-badge">
                            <span class="badge badge-pill badge-secondary ">{{patient.Bed}}</span>
                            <span *ngIf="isInTheatre" class="badge badge-pill blue-background">In Theatre </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngSwitchCase="'theatre-patient-card'" class="patient-card card" (click)="selectPatient()">
        <div class="card-body">
            <h5 class="card-title"><b>{{patient.Name}}</b></h5>
            <h6 class="card-subtitle mb-2 text-muted">Case no: {{patient.CaseNumber}}</h6>
            <h6 class="card-subtitle mb-2 text-muted" *ngIf="patient.OperatingStartDate > '1900-01-02'">Start Date:
                {{ patient.OperatingStartDate | date:'medium' }}
            </h6>
            <h6 class="card-subtitle mb-2 text-muted" *ngIf="patient.OperatingEndDate > '1900-01-02'">End Date:
                {{ patient.OperatingEndDate | toLocalDate | date:'medium' }}
            </h6>
            <h6 class="card-subtitle mb-2 text-muted" *ngIf="isPendingSubmit">Submitting to SAP at
                {{ submittingToSapDate | toLocalDate | date:'medium' }}
            </h6>
            <div class="patient-card-pills">
                <div class="patient-card-badge card-text" *ngIf="patient.TimeInOperatingRoomSeconds != 0">
                    <span class="badge badge-pill blue-background">TIME IN
                        OR
                        {{ patient.TimeInOperatingRoomSeconds * 1000 | date:'H:mm:ss':'UTC' }}</span>
                </div>
                <div class="" *ngIf="isInTheatreRecovery || isPendingSubmit">
                    <span class="badge badge-pill green-background">TIME IN RECOVERY
                        {{ patient.TimeInRecoveryRoomSeconds * 1000 | date:'H:mm:ss':'UTC'}}</span>
                </div>
            </div>
            <div *ngIf="showCheckListProgressBar">
                <app-gradient-progress-bar [currentValue]="currentStep" [maxValue]="totalSteps" [showLabel]="true" height="16px"
                    borderRadius="8px">
                </app-gradient-progress-bar>
            </div>
        </div>
    </div>

    <div *ngSwitchCase="'theatre-patient-history-card'" class="patient-card card" (click)="selectPatient()">
        <div class="card-body">
            <h5 class="card-title"><b>{{patient.name}}</b></h5>
            <h6 class="card-subtitle mb-2 text-muted">Case no: {{patient.caseNumber}}</h6>
            <h6 class="card-subtitle mb-2 text-muted">Start Date:
                {{ patient.operatingStartDate | date:'medium' }}
            </h6>
            <h6 class="card-subtitle mb-2 text-muted">End Date:
                {{ patient.operatingEndDate | toLocalDate | date:'medium' }}
            </h6>
            <div class="patient-card-pills">
                <div class="patient-card-badge card-text" *ngIf="patient.timeInOperatingRoomSeconds != 0">
                    <span class="badge badge-pill blue-background">TIME IN
                        OR
                        {{ patient.timeInOperatingRoomSeconds * 1000 | date:'H:mm:ss':'UTC'}}</span>
                </div>
                <div class="patient-card-badge card-text" *ngIf="patient.timeInRecoveryRoomSeconds != 0">
                    <span class="badge badge-pill green-background">TIME IN RECOVERY
                        {{ patient.timeInRecoveryRoomSeconds * 1000 | date:'H:mm:ss':'UTC'}}</span>
                </div>
            </div>
        </div>
    </div>

    <div *ngSwitchCase="'whiteboard-patient-card'" class="card"
        [ngClass]="{'patient-icu-container': patient.CanBeMovedToICU, 'whiteboard-card': !patient.CanBeMovedToICU}"
        [class.mat-elevation-z2]="true">
        <div class="card-body" *ngIf="patient.Id">
            <div class="flex-div">
                <div class="patient-information">
                    <h2 class="card-title title-margin t5"><b>{{patient.Bed}}</b></h2>
                    <span class="t4"><b>{{patient.Name}}</b></span>
                </div>
                <div *ngIf="isInTheatre && !patient.CanBeMovedToICU">
                    <span class="badge badge-pill badge-secondary t2">IN THEATRE</span>
                </div>
                <div *ngIf="patient.CanBeMovedToICU">
                    <span class="badge badge-pill badge-move-to-icu t3">MOVE TO ICU</span>
                </div>
            </div>
            <h6 class="card-subtitle t3 mb-2 mt-2 text-muted"><b>{{patient?.AttendingPhysicianTitle}}
                    {{patient?.AttendingPhysicianName}}</b></h6>
            <div class="admission-date">
                <h6 *ngIf="patient.AdmittedDate" class="card-subtitle t3 mb-2 mt-2 text-muted admission-date">
                    Admitted:
                    {{patient.AdmittedDate | date: 'MM.dd.yyyy h:mm:ss' }}
                </h6>
            </div>
        </div>
    </div>

    <div *ngSwitchCase="'empty-bed-card'" class="whiteboard-card empty-bed-border">
        <div class="empty-bed">
            <div class="bed-number t4 text-muted">
                {{bed.description}}
            </div>
            <div class="bed-icon">
                <mat-icon svgIcon="hospital-bed"></mat-icon>
            </div>
            <div class="bed-subtitle text-muted">
                No patient assigned
            </div>
        </div>
    </div>

    <div *ngSwitchCase="'tis-scoring-card'" class="patient-card card" (click)="selectPatient()">
        <div class="row">
            <div class="col">
                <div class="card-body">
                    <h5 class="card-title"><b>{{patient.Name}}</b></h5>
                    <h6 class="card-subtitle mb-2 text-muted">Case no: {{patient.CaseNumber}}</h6>
                    <div class="grid-chip-div">
                        <p class="patient-card-badge tis-scoring-patient-card-badge">
                            <span class="badge badge-pill badge-secondary ">{{patient.Bed}}</span>
                        </p>
                        <p class="patient-card-badge tis-scoring-patient-card-badge">
                            <span *ngIf="patient.LastScored   != '0001-01-01T00:00:00'"
                                class="badge badge-pill blue-background">Last scored {{ patient.LastScored | toLocalDate
                                | date: 'medium' }} </span>

                        </p>
                        <p class="patient-card-badge tis-scoring-patient-card-badge">
                            <span *ngIf="patient.LastScore   != undefined && patient.LastScore == 'Green'"
                                class="badge badge-pill green-background">Last score ({{ patient.LastScore }}) </span>
                            <span *ngIf="patient.LastScore   != undefined && patient.LastScore == 'Orange'"
                                class="badge badge-pill orange-background">Last score ({{ patient.LastScore }}) </span>
                            <span *ngIf="patient.LastScore   != undefined && patient.LastScore == 'Yellow'"
                                class="badge badge-pill yellow-background">Last score ({{ patient.LastScore }}) </span>
                            <span *ngIf="patient.LastScore   != undefined && patient.LastScore == 'Red'"
                                class="badge badge-pill red-background">Last score ({{ patient.LastScore }}) </span>
                            <span
                                *ngIf="patient.LastScore   != undefined && patient.LastScore != 'Green' && patient.LastScore != 'Orange' && patient.LastScore != 'Yellow' && patient.LastScore != 'Red'"
                                class="badge badge-pill blue-background">Last score ({{ patient.LastScore }}) </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>